import _ from 'underscore';

export default function CreativeListService(
  $q,
  DataService,
  PreviewGroupService
) {
  const vm = this;

  vm.creativesAndGroups = [];
  vm.mergeCreativesAndGroups = mergeCreativesAndGroups;
  vm.initUserCreativesAndGroups = initUserCreativesAndGroups;
  vm.refreshList = refreshList;

  function mergeCreativesAndGroups(sortOrder) {
    let combinedArr = PreviewGroupService.userGroups.concat(
      DataService.userCreatives
    );

    vm.creativesAndGroups = _.sortBy(combinedArr, item => {
      return item[sortOrder];
    }).reverse();
    return vm.creativesAndGroups;
  }

  function initUserCreativesAndGroups(sortOrder = 'updatedAt') {
    return $q
      .all([
        DataService.initUserCreatives(),
        PreviewGroupService.initUserGroups()
      ])
      .then(() => {
        return mergeCreativesAndGroups(sortOrder);
      });
  }

  function refreshList(sortOrder = 'updatedAt') {
    return $q
      .all([
        PreviewGroupService.updateUserGroups(),
        DataService.updateUserCreatives()
      ])
      .then(() => mergeCreativesAndGroups(sortOrder));
  }

  return vm;
}

CreativeListService.$inject = ['$q', 'DataService', 'PreviewGroupService'];
